import * as React from 'react';
import { LIST_ROW_HEIGHTS } from '../../../../constants/list_row_heights';
import { IListRowRenderProps, ITag } from '../../../../data/types';
import { SelectBox } from '../../../shared/form/SelectBox';
import { List } from '../../../shared/List/List';
import { ListControlContainer } from '../../../shared/List/ListControlContainer';
import {
  ListItem,
  ListItemCell,
  ListItemSafeText,
} from '../../../shared/List/ListItem';
import { ISelectedTagMap } from './EditTests';

interface IProps {
  tags: ITag[];
  onSelect: (tag: ITag, action: 'add' | 'remove') => void;
  selectedTags: ISelectedTagMap;
}

export const TagList = (props: IProps): React.ReactElement => {
  const listShape = [2, 1];

  /**
   * @description render function for list items
   * @param param0
   */
  const rowRenderer = ({
    index,
    key,
    style,
  }: IListRowRenderProps): React.ReactElement => {
    const tag = props.tags[index];
    return (
      <TagListItem
        style={style}
        tag={tag}
        key={key}
        shape={listShape}
        onSelect={props.onSelect}
        selected={props.selectedTags?.[tag.id]?.state}
      />
    );
  };
  return (
    <ListControlContainer>
      <List
        rowRenderer={rowRenderer}
        listLength={props.tags.length}
        rowHeight={LIST_ROW_HEIGHTS.normal}
      />
    </ListControlContainer>
  );
};

interface ITagListItemProps {
  style?: React.CSSProperties;
  tag: ITag;
  shape: number[];
  onSelect: (tag: ITag, action: 'add' | 'remove') => void;
  selected: boolean;
}
const TagListItem = (props: ITagListItemProps): React.ReactElement => {
  const selectHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.checked) {
      props.onSelect(props.tag, 'add');
    } else {
      props.onSelect(props.tag, 'remove');
    }
  };
  return (
    <ListItem style={props.style}>
      <ListItemCell style={{ flex: props.shape[0], flexDirection: 'column' }}>
        <div>
          <ListItemSafeText>{props.tag.name}</ListItemSafeText>
        </div>
        <div>
          <ListItemSafeText style={{ color: 'var(--color-secondary-text' }}>
            {props.tag.description}
          </ListItemSafeText>
        </div>
      </ListItemCell>
      <ListItemCell style={{ flex: props.shape[1] }}>
        <SelectBox selected={props.selected} onSelect={selectHandler} />
      </ListItemCell>
    </ListItem>
  );
};
